"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.domElements = void 0;
exports.domElements = ['a', 'article', 'aside', 'blockquote', 'button', 'caption', 'cite', 'circle', 'code', 'dd', 'div', 'dl', 'dt', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hr', 'img', 'input', 'kbd', 'label', 'li', 'mark', 'nav', 'ol', 'p', 'path', 'pre', 'q', 'rect', 's', 'svg', 'section', 'select', 'small', 'span', 'sub', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'tr', 'ul'];